import { SortType } from '@gp/enums/common';
import { DEFAULT_PAGINATION, DEFAULT_SEARCH } from '@gp/constants/const';

// import type { Action, Reducer, Effect } from 'umi';
import type { Action, Reducer } from 'umi';
import type { PagingQuery } from 'tea-component';
import type { SortBy } from 'tea-component/lib/table/addons';
import type { IPayload, ISearchPayloadPageStore } from '@gp/types/global';
import type { IPipelineChangeChecklistFilterVO, IPipelineChangeChecklistRecordVO } from '@gp/types/changeLog';

export interface ILockerData {
  lock: boolean;
  filter: IPipelineChangeChecklistFilterVO;
  sort: SortBy<IPipelineChangeChecklistRecordVO>[];
  pagination: PagingQuery;
  search: ISearchPayloadPageStore;
}

type IUpdateLockerDataAction = Action<'updateLockerData'> & IPayload<any>;
type IClearLockerDataAction = Action<'clearLockerData'> & IPayload<unknown>;

interface ILockerModel {
  namespace: string;
  state: ILockerData;
  reducers: {
    updateLockerData: Reducer<ILockerData, IUpdateLockerDataAction>;
    clearLockerData: Reducer<ILockerData, IClearLockerDataAction>;
  };
  effects: {};
}

export const LOCKER_MODEL_NAMESPACE = 'dbg-model-pipeline-change-log-change-checklist-locker';

export const DEFAULT_FILTER: IPipelineChangeChecklistFilterVO = {
  rangePicker: {
    dateType: 'month',
    startDate: '',
    endDate: '',
  },
  priority: [],
  pteam: [],
  stage: [],
};

export const DEFAULT_SORT: SortBy<IPipelineChangeChecklistRecordVO>[] = [{ by: 'priority', order: SortType.Desc }];

export const DEFAULT_LOCKER_DATA: ILockerData = {
  lock: false,
  filter: DEFAULT_FILTER,
  sort: DEFAULT_SORT,
  pagination: DEFAULT_PAGINATION,
  search: DEFAULT_SEARCH,
};

const LockerModel: ILockerModel = {
  namespace: LOCKER_MODEL_NAMESPACE,
  state: DEFAULT_LOCKER_DATA,
  reducers: {
    updateLockerData(state, action) {
      return { ...state, ...action?.payload, lock: true };
    },
    clearLockerData(state) {
      return { ...state, ...DEFAULT_LOCKER_DATA, lock: false };
    },
  },
  effects: {},
};

export default LockerModel;
